export default __webpack_public_path__ + "static/media/background_account_stats.387b2660.png";